import { useDispatch } from 'react-redux'
import { UseMutationOptions, useMutation } from '@cbgms/base/http/use-query'
import { UploadImageResponse, uploadImage } from './actions'
import { MediaCategory } from './media-category'

export const useUploadImage = (category: MediaCategory, options?: UseMutationOptions<UploadImageResponse, unknown, File, unknown>) => {
  const dispatch = useDispatch()

  return useMutation(async image => {
    return dispatch(uploadImage(category, image))
  }, options)
}
